import { render, staticRenderFns } from "./revenueBills-list.vue?vue&type=template&id=3676774c&scoped=true&"
import script from "./revenueBills-list.vue?vue&type=script&lang=js&"
export * from "./revenueBills-list.vue?vue&type=script&lang=js&"
import style0 from "./revenueBills-list.vue?vue&type=style&index=0&id=3676774c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676774c",
  null
  
)

export default component.exports